import { Box, Button, Typography } from '@mui/material';
import { format, setMinutes } from 'date-fns';
import React from 'react';

const TerminSlotComponent = ({ slot, selectedSlot, setSelectedSlot, setValue }) => {
  return (
    <Button
      variant="contained"
      sx={(theme) => ({
        bgcolor: selectedSlot === slot.id ? theme.palette.secondary.main : '#fff',
        color: selectedSlot === slot.id ? '#fff' : theme.palette.secondary.main,
        textTransform: 'none',
        borderRadius: '15px',
        fontWeight: '700',
        padding: '8px 12px',
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        '&:hover': {
          color: '#fff',
          bgcolor: theme.palette.secondary.main + 'CC',
        },
      })}
      onClick={() => {
        setValue('from.hour', slot.from.hour);
        setValue('from.minute', slot.from.minute);
        setValue('to.hour', slot.to.hour);
        setValue('to.minute', slot.to.minute);
        setSelectedSlot(selectedSlot === slot.id ? undefined : slot.id);
      }}
    >
      <Typography>{slot.label}</Typography>
      <Box display="flex">
        <Typography>{format(setMinutes(new Date().setHours(slot.from.hour), slot.from.minute), 'HH:mm')}</Typography>
        <Typography> - </Typography>
        <Typography>{format(setMinutes(new Date().setHours(slot.to.hour), slot.to.minute), 'HH:mm')}</Typography>
      </Box>
    </Button>
  );
};

export default TerminSlotComponent;
